import {
  ColorPalette,
  Pagination,
  PaginationParams,
  ProposalTemplate,
  Style,
  TemplateProduct,
  TemplateProductPayload
} from 'src/common/common.interface'
import {
  CustomizationGroup,
  SaveCustomizationGroupPayload,
  SaveProductCustomizationPayload,
  SaveProductCustomizationResult
} from 'src/common/customization.interface'
import { getHttp, postHttp, putHttp } from './apiLayer'
import { handleGetAllData } from './helper'

export const checkIsTemplateProduct = async (productId: number): Promise<boolean> => {
  const result = await getHttp(`products/${productId}/is-template-product`)
  return result.data
}

export const getListProposalTemplates = async (params: PaginationParams): Promise<Pagination<ProposalTemplate[]>> => {
  const result = await getHttp(`proposal-templates`, { params })
  return result.data
}

export const getListColorPalettes = async (params: PaginationParams): Promise<Pagination<ColorPalette[]>> => {
  const result = await getHttp(`color-palettes`, { params })
  return result.data
}

export const getAllStyles = async () => {
  const resultData = await handleGetAllData<Style>('styles', 100)

  return resultData as Style[]
}

export const getTemplateProducts = async (params: {
  templateId: number
  includeCustomization?: boolean
}): Promise<Pagination<TemplateProduct[]>> => {
  const result = await getHttp(`proposal-templates/${params.templateId}/products`, {
    params: { includeCustomization: params.includeCustomization }
  })
  return result.data
}

export const getProposalTemplate = async (templateId: number): Promise<ProposalTemplate> => {
  const result = await getHttp(`proposal-templates/${templateId}`)
  return result.data
}

export const updateProposalTemplate = async (
  templateId: number,
  payload: TemplateProductPayload
): Promise<ProposalTemplate> => {
  const result = await putHttp(`proposal-templates/${templateId}`, payload)
  return result.data
}

export const getCustomizationGroups = async (): Promise<CustomizationGroup[]> => {
  const result = await getHttp(`customization-groups`)
  return result.data
}

export const saveProductCustomizations = async (
  payload: SaveProductCustomizationPayload[]
): Promise<SaveProductCustomizationResult[]> => {
  const result = await postHttp(`save-product-customizations`, payload)
  return result.data
}

export const saveCustomizationGroups = async (
  payload: SaveCustomizationGroupPayload[]
): Promise<CustomizationGroup[]> => {
  const result = await putHttp(`customizationGroups`, payload)
  return result.data
}
